// Class: openfl.net.FileFilter

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var FileFilter = function(description,extension,macType) {
	this.description = description;
	this.extension = extension;
	this.macType = macType;
}

// Meta

FileFilter.__name__ = "openfl.net.FileFilter";
FileFilter.__isInterface__ = false;
FileFilter.prototype = {
	
};
FileFilter.prototype.__class__ = FileFilter.prototype.constructor = $hxClasses["openfl.net.FileFilter"] = FileFilter;

// Init



// Statics




// Export

exports.default = FileFilter;